export enum TransferStatus {
  Created = 'Created',
  Reviewed = 'Reviewed',
  Completed = 'Completed',
  Rejected = 'Rejected',
}
